// note: general import
import * as React from "react";

// note: MUI import
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

// note: utils import
// import { CloseIcon } from "utils/asset";

// position: Add property anchorOrigin with values {vertical: top/bottom, horizontal: center/right/left}
export function MCSnackbarsBV1({
  // MC = MUI Core
  open,
  message,
  autoHideDuration = 6000,
  action,
  handleClose,
}) {
  // const handleClose = (_, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpen(false);
  // };

  // const action = (
  //   <>
  //     <Button color="secondary" size="small" onClick={handleClose}>
  //       UNDO
  //     </Button>
  //     <IconButton
  //       size="small"
  //       aria-label="close"
  //       color="inherit"
  //       onClick={handleClose}
  //     >
  //       <CloseIcon fontSize="small" />
  //     </IconButton>
  //   </>
  // );

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      message={message}
      action={action}
    />
  );
}

// note: alert severity: (success, info, warning, error)
export function MCSnackbarsBV2({
  open,
  severity = "success",
  message,
  autoHideDuration = 6000,
  handleClose,
  position = { vertical: "bottom", horizontal: "center" },
  variant = "filled",
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={position}
    >
      <Alert onClose={handleClose} severity={severity} variant={variant}>
        <Typography variant="subtitle2">{message}</Typography>
      </Alert>
    </Snackbar>
  );
}

export function MCSnackbarsBV3({
  open,
  severity = "success",
  message,
  handleCloseSnackbar
}) {
  return (
    <Snackbar
    open={open}
    autoHideDuration={3000}
    onClose={handleCloseSnackbar}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <Alert
      onClose={handleCloseSnackbar}
      severity={severity}
      sx={{
        bgcolor: "#166534",
        color: "white",
        ".MuiAlert-icon": {
          color: "white",
        },
        ".MuiAlert-action": {
          color: "white",
        },
      }}
    >
      {message}
    </Alert>
  </Snackbar>
  )
}